import { render, staticRenderFns } from "./En.vue?vue&type=template&id=0c49a9c0&"
import script from "./En.vue?vue&type=script&lang=ts&"
export * from "./En.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports